import { Row, Column, Text } from '@simplywallst/ui-core';
import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

interface PlansContainerProps {
  hideFreePlan: boolean;
}

interface PlanProps {
  planType: string;
}

interface FeatureItemProps {
  notIncluded: boolean;
}

interface AddedFeaturesProps {
  darkBackground: boolean;
}

interface FeatureItemProps {
  notIncluded: boolean;
}

export const PlansContainer = styled(Row)<PlansContainerProps>`
  color: ${({ theme }) => theme.color.spaceGray};
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${({ hideFreePlan }) =>
    hideFreePlan ? `min-height: 1178px;` : `min-height: 1762px;`}

  ${media.mdUp`
    ${({ hideFreePlan }) => hideFreePlan && 'width: 680px;'}
    margin-bottom: 30px;
    min-height: 784px;
    min-width: 700px;
  `}
  ${media.lgUp`
    ${({ hideFreePlan }) => hideFreePlan && 'width: 810px;'}
    min-width: 1136px;
  `}


  > p {
    color: ${({ theme }) => theme.color.brand01};
    ${media.mdUp`
      padding-top: 20px;
    `}
    svg {
      margin-left: ${({ theme }) => theme.x1spacePx}px;
      vertical-align: text-bottom;
      ${({ theme }) => theme.typography.base}
      fill: ${({ theme }) => theme.color.brand01};
      width: 20px;
      height: 20px;
    }
  }
`;

export const PlanContainer = styled(Column)`
  padding: 4px ${({ theme }) => theme.x3spacePx}px;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  max-width: 42rem;
  ${media.mdUp`
    padding: 4px ${({ theme }) => theme.x1spacePx}px;
  `}
  ${media.lgUp`
    padding: 4px ${({ theme }) => theme.x2spacePx}px;
  `}
  h2 {
    ${({ theme }) => theme.typography.mega};
  }
`;

export const PlanContent = styled('div')<PlanProps>`
  padding: ${({ theme }) => theme.x3spacePx}px
    ${({ theme }) => theme.x4spacePx}px;
  padding-bottom: ${({ theme }) => theme.x4spacePx}px;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.x2spacePx}px;
  text-align: center;
  min-height: 41rem;
  ${media.mdUp`
    min-height: 53rem;
  `}
  h2 {
    ${({ theme }) => theme.typography.megaStrong}
    margin: 0px;
  }
  p {
    margin-bottom: 0px;
    mark {
      font-size: 3.2rem;
      font-weight: 700;
      background-color: ${({ theme }) => theme.color.white};
      color: ${({ theme }) => theme.color.spaceGray};
    }
    &:nth-child(3) {
      width: 200px;
      margin: 0rem auto 1.2rem auto;
    }
  }
  ul {
    text-align: left;
    width: fit-content;
    margin: 0 auto;
    ${({ theme }) => theme.typography.large}
    margin-top: 1.2rem;
    ${media.mdUp`
      ${({ theme }) => theme.typography.small}
    `}
    ${media.lgUp`
      ${({ theme }) => theme.typography.base}
    `}
  }
`;

export const BillingPeriodTextContainer = styled('div')`
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x2spacePx}px;
`;

export const MarketingText = styled('p')`
  height: 52px;
  margin-bottom: 16px !important;
`;

export const AddedFeatures = styled('ul')<AddedFeaturesProps>`
  width: fit-content;
  margin: 0 auto;
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
  width: 100%;
  text-align: left;
  ${({ theme }) => theme.typography.base}
  padding: 28px 0 18px;
  ${media.mdUp`
    text-align: center;
    padding: 35px 0 18px;
  `}
  > li {
    padding-left: ${({ theme }) => theme.x3spacePx}px;
    ${media.mdUp`
      display: inline;
    `}
  }
  ${({ darkBackground }) =>
    darkBackground &&
    css`
      li {
        color: ${({ theme }) => theme.color.textSubtle};
        svg {
          fill: ${({ theme }) => theme.color.white};
        }
      }
    `}
`;

export const FeatureItem = styled('li')<FeatureItemProps>`
  ${({ theme }) => theme.typography.small}
  ${({ notIncluded }) => notIncluded && 'opacity: 0.5;'}
  padding: 4px 0 0 0;
  width: fit-content;
  svg {
    fill: ${({ theme, notIncluded }) =>
      notIncluded ? theme.color.charcoalRGBA(1) : theme.color.brand01};
    vertical-align: middle;
    margin-right: 0.8rem;
    margin-bottom: 2px;
    width: 2.4rem;
  }
  div {
    display: flex;
  }
`;

export const StyledText = styled(Text)<{ darkBackground: boolean }>`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme, darkBackground }) =>
    darkBackground ? theme.color.textSubtle : theme.color.spaceGrayRGBA(0.7)};
  border-bottom: 1px dotted
    ${({ theme, darkBackground }) =>
      darkBackground ? theme.color.textSubtle : theme.color.spaceGrayRGBA(0.7)};
`;
